"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withAuthSession;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _actionType = require("../../actionType");

var _marked =
/*#__PURE__*/
_regenerator.default.mark(withAuthSession);

function withAuthSession(task) {
  return _regenerator.default.wrap(function withAuthSession$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 7;
            break;
          }

          _context.next = 3;
          return (0, _effects.take)(_actionType.AUTH_SESSION_START);

        case 3:
          _context.next = 5;
          return (0, _effects.race)({
            task: (0, _effects.call)(task),
            abort: (0, _effects.take)(_actionType.AUTH_SESSION_END)
          });

        case 5:
          _context.next = 0;
          break;

        case 7:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}